<template>
  <v-dialog v-model="isVisible" max-width="650px">
    <v-card :style="{ borderRadius: '12px' }">
      <v-card-title :style="{
        background: 'linear-gradient(135deg, rgb(0, 109, 62) 0%, rgb(0, 85, 48) 100%)',
        color: 'white',
        fontWeight: '700',
        fontSize: '20px',
        borderRadius: '12px 12px 0 0',
        padding: '20px'
      }">Terms of service</v-card-title>
      <v-card-text class="terms-content" v-html="formattedTerms"></v-card-text>
      <v-card-actions :style="{
        padding: '16px 20px',
        backgroundColor: '#f5f7fa',
        borderTop: '1px solid #e2e8f0',
        borderRadius: '0 0 12px 12px'
      }">
        <v-spacer />
        <v-btn
          @click="closeDialog"
          :style="{
            backgroundColor: foregroundColor,
            color: backgroundColor,
            textTransform: 'none',
            fontWeight: '600',
            fontSize: '14px',
            borderRadius: '999px',
            padding: '8px 22px',
            border: 'none',
          }"
          class="close-terms-btn"
        >Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    formattedTerms: {
      type: String,
      default: "",
    },
    modelValue: {
      type: Boolean,
      default: false,
    },
    foregroundColor: {
      type: String,
      default: "rgb(0, 0, 0)",
    },
    backgroundColor: {
      type: String,
      default: "primary",
    },
  },
  computed: {
    isVisible: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  methods: {
    closeDialog() {
      this.isVisible = false;
    },
  },
};
</script>

<style scoped>
.terms-content {
  max-height: 315px;
  overflow-y: auto;
  white-space: pre-wrap;
  padding: 24px;
  line-height: 1.7;
}

.close-terms-btn {
  box-shadow: 0 2px 8px rgba(0, 109, 62, 0.2) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  border-radius: 999px !important;
}

.close-terms-btn:hover {
  box-shadow: 0 4px 16px rgba(0, 109, 62, 0.3) !important;
  transform: translateY(-1px);
}
</style>
